export function fixGetManySpecialistCards(json) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            specialistCardId: resource.objectId,
        })),
    };
}

export function specialistCardMapperListResponse(json, headers) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId,
            specialistCardId: resource.objectId,
        })),
        total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
}

export function fixCreateSpecialistCardId(params, json) {
    return {
        data: {...params.data, id: json.result.objectId},
    };
}

export function specialistCardMapperGetOneResponse(json) {
    return {
        data: {
            ...json.result,
            id: json.result.objectId, specialistCardId: json.result.objectId,
        }
};
}

export function fixUpdateSpecialistCardId(json) {
    return {
        data: {...json, id: json.objectId},
    };
}